import {Component, OnDestroy, OnInit} from '@angular/core';
import {SitesService} from '../../services/sites.service';
import {ActivatedRoute} from '@angular/router';
import {Subscription} from 'rxjs/Subscription';
import * as moment from 'moment';
import {DatePickerModeEnum} from '../../models/DatePickerModeEnum';
import {GetAverageScoreAccumulatorResponseDto} from '../../models/GetAverageScoreAccumulatorResponseDto';
import {BaseAfterViewInitComponent} from '../base-components/after-view-init/base-after-view-init.component';
import {AverageScoreAccumulatorsService} from '../../services/average-score-accumulators.service';
import {GetSiteResponseDto} from '../../models/GetSiteResponseDto';
import {GetCustomerResponseDto} from '../../models/GetCustomerResponseDto';
import {CustomersService} from '../../services/customers.service';
import {GetTriggerCategoryResponseDto} from '../../models/GetTriggerCategoryResponseDto';
import {TriggerCategoriesService} from '../../services/trigger-categories.service';
import {GetSitePageResponseDto} from '../../models/GetSitePageResponseDto';
import {SitePagesService} from '../../services/site-pages.service';
import {setInterval, clearInterval} from 'timers';
import {ToastsManager} from 'ng2-toastr';

@Component({
  selector: 'app-site',
  templateUrl: './site.component.html',
  styleUrls: ['./site.component.css']
})
export class SiteComponent extends BaseAfterViewInitComponent implements OnInit, OnDestroy {
    site: GetSiteResponseDto;
    customer: GetCustomerResponseDto;
    triggerCategory: GetTriggerCategoryResponseDto;
    siteLoadedSubscription: Subscription;
    averageScoreAccumulatorsLoadedSubscription: Subscription;
    addSitePageSuccessSubscription: Subscription;
    selectedDate: moment.Moment;
    selectedAverageScoreAccumulator: GetAverageScoreAccumulatorResponseDto;
    DatePickerModeEnum = DatePickerModeEnum;
    maxGetNewlySitePageScoresRequests = 30;

    constructor(
        private sitesService: SitesService,
        private sitePagesService: SitePagesService,
        private averageScoreAccumulatorsService: AverageScoreAccumulatorsService,
        private customersService: CustomersService,
        private triggerCategoriesService: TriggerCategoriesService,
        private toastr: ToastsManager,
        private route: ActivatedRoute) {
        super();
    }

    ngOnInit() {
        this.route.params.subscribe((params => {
            this.sitesService.getById(params.id);
            this.siteLoadedSubscription = this.sitesService.getOnSiteLoadedSubject()
                .subscribe(site => {
                    this.site = site;

                    this.getSitePagesScores();

                    this.triggerCategoriesService.getTriggerCategoryById(site.triggerCategoryId).
                        subscribe(response => {this.triggerCategory = response.body; });

                    this.customersService.getByCrmId(this.site.crmId)
                        .subscribe(response => { this.customer = response.body; });
            });
        }));

        this.averageScoreAccumulatorsLoadedSubscription = this.averageScoreAccumulatorsService.getAverageScoreAccumulatorsLoadedSubject().subscribe(data => {
            this.selectedAverageScoreAccumulator = data[2];
        });

        this.addSitePageSuccessSubscription = this.sitePagesService.getAddSitePageSuccessSubject()
            .subscribe(sitePage => {
                this.getNewlyAddedSitePageScores(sitePage);
            });
    }

    onDateSelected(date: moment.Moment) {
        this.selectedDate = date;
        if (this.childrenInitialized) {
            this.getSitePagesScores();
        }
    }

    onAverageScoreAccumulatorSelected(averageScoreAccumulator: GetAverageScoreAccumulatorResponseDto) {
        this.selectedAverageScoreAccumulator = averageScoreAccumulator;
        this.getSitePagesScores();
    }

    getSitePagesScores(): void {
        // Handle first time request, when score accumulator and date components are not being loaded yet.
        const accumulatorId = this.selectedAverageScoreAccumulator === undefined ? 3 : this.selectedAverageScoreAccumulator.id;
        this.sitesService.getSitePagesScores(this.site.id, accumulatorId, this.selectedDate.format('YYYY-MM-DD'));
    }

    private getNewlyAddedSitePageScores(sitePage: GetSitePageResponseDto) {
        let requestCounter = 0;
        const interval = setInterval(() => {
            this.sitePagesService.getSitePageScores(sitePage.id, this.selectedAverageScoreAccumulator.id, this.selectedDate.format('YYYY-MM-DD'))
                .subscribe(response => {
                    if (response.status === 200) {
                        this.sitePagesService.newlyAddedSitePageScoresReceived(response.body);
                        clearInterval(interval);
                        return;
                    }
                    console.log(response);
                }, error => {
                    if (error.status === 404) {
                        if (requestCounter > this.maxGetNewlySitePageScoresRequests) {
                            clearInterval(interval);
                            return;
                        }
                    } else {
                        this.toastr.error(error.error);
                    }
                });
            requestCounter++;
        }, 1000);
    }

    ngOnDestroy(): void {
        this.siteLoadedSubscription.unsubscribe();
        this.averageScoreAccumulatorsLoadedSubscription.unsubscribe();
        this.addSitePageSuccessSubscription.unsubscribe();
    }
}



// WEBPACK FOOTER //
// C:/Visual Studio Projects/Novicell Performance Platform/PerformancePlatform/Novicell.Performance.Website/ui/src/app/components/site/site.component.ts